import type {
  ShipmentDocumentType,
  ShipmentOfficialDocument,
} from '@/services/api/shipments';

/**
 * Dokumen Resmi on a 4W shipment, as the ops app shows it
 * (PLAN-SHIPMENT-DOCS-DYNAMIC): AGL Patimban keeps fixed slots per EXIM
 * direction; every other client's documents are named by ops (`doc_<name>`,
 * with the name in `label`) and listed as they are.
 */

type DocSlot = { type: ShipmentDocumentType; label: string };

export const EXPORT_DOCS: DocSlot[] = [
  { type: 'surat_jalan', label: 'Surat Jalan' },
  { type: 'surat_dn', label: 'Surat DN' },
  { type: 'dokumen_timbang_akhir', label: 'Dokumen Hasil Timbang Akhir' },
  { type: 'eir_delivery', label: 'EIR Delivery' },
  { type: 'eir_receiving', label: 'EIR Receiving' },
];

export const IMPORT_DOCS: DocSlot[] = [
  { type: 'surat_jalan', label: 'Surat Jalan' },
  { type: 'bl', label: 'BL' },
  { type: 'eir_delivery', label: 'EIR Delivery' },
  { type: 'eir_receiving', label: 'EIR Receiving' },
];

const SLOT_LABELS: Record<string, string> = Object.fromEntries(
  [...EXPORT_DOCS, ...IMPORT_DOCS].map((d) => [d.type, d.label])
);

/** Same rule as the ops app: the client's name contains "patimban". */
export const isPatimbanClient = (name?: string | null): boolean =>
  !!name && name.toLowerCase().includes('patimban');

/** What to call a stored document: the name ops typed, the slot's label, or the key. */
export const documentLabel = (
  key: string,
  doc: ShipmentOfficialDocument
): string => doc.label ?? SLOT_LABELS[key] ?? key;

/** Every stored document, oldest upload first. */
export const storedDocuments = (
  documents: Record<string, ShipmentOfficialDocument> | null | undefined
): [string, ShipmentOfficialDocument][] =>
  Object.entries(documents ?? {}).sort(([, a], [, b]) =>
    (a.uploadedAt ?? '').localeCompare(b.uploadedAt ?? '')
  );
